import { connect } from 'react-redux'

import { getActivityId, getIsFavorite } from 'store/entities/activity/selectors'
import UserActivityDonePanel from 'app/domains/common/UserActivityDonePanel'

const mapStateToProps = state => ({
  activityId: getActivityId(state),
  isFavorite: getIsFavorite(state),
})

export default connect(mapStateToProps)(UserActivityDonePanel)
